'use client';

import { createContext, useContext, type FC, type ReactNode } from 'react';
import type { CurrentUser } from '@/lib/types/auth.types';

const CurrentUserContext = createContext<CurrentUser | null>(null);

interface CurrentUserProviderProps {
  currentUser: CurrentUser;
  children: ReactNode;
}

export const CurrentUserProvider: FC<CurrentUserProviderProps> = ({ children, currentUser }) => {
  return <CurrentUserContext.Provider value={currentUser}>{children}</CurrentUserContext.Provider>;
};

export function useCurrentUser() {
  return useContext(CurrentUserContext);
}
